export const backendserverurl='https://1xx-a-be-back0000122-data.wagerwyze.online'